import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { getFaq } from "@/lib/api";
import FAQView from "@/components/previews/FAQView";

export default function EmbedFAQ() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let c = false;
    getFaq(id)
      .then((d) => { if (!c) setData(d); })
      .catch(() => { if (!c) setErr(true); })
      .finally(() => { if (!c) setLoading(false); });
    return () => { c = true; };
  }, [id]);

  return (
    <div className="min-h-screen bg-white" data-testid="embed-faq-page">
      <div className="max-w-2xl mx-auto px-6 py-10">
        {loading ? (
          <div className="grid place-items-center h-64 text-zinc-400">
            <Loader2 className="h-5 w-5 animate-spin" />
          </div>
        ) : err || !data ? (
          <div className="text-center text-zinc-500 text-sm mt-20">Component not found.</div>
        ) : (
          <FAQView data={data} />
        )}
      </div>
    </div>
  );
}
